var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{style:({background: _vm.$vuetify.theme.themes[_vm.theme].background})},[_c('NavBar',{attrs:{"open":_vm.toggle}}),_c('SideBar'),_c('v-main',[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('router-view')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }